var player = {};

$(document).ready(function () {

	if ( window.location.hash.match(/#show[1,2]/g) ) {
		var target = $('a[href=#video'+window.location.hash.slice(window.location.hash.length-1)+']');
		target.trigger('click');
	}

	$('.streetpicker').selectpicker({
	  style: 'btn-select'
	});

	$('.regulament').click(function(){
		ga('send','event','StreetFood 2017','Regulament','Download');
	});

	$('.castigatori').click(function(){
		ga('send','event','StreetFood 2017','Castigatori','Download');
	});

	$('a.video-btn').on('mouseover',function(){
		$(this).parent().nextAll('.video-content').addClass('over');
	}).on('mouseleave',function(){
		$(this).parent().nextAll('.video-content').removeClass('over');
	});

	$(document).delegate('.video-question--disabled label', 'click', function(){
		if ($('.tab-pane.active .message').length) {
			$('.message').hide();
			$('.tab-pane.active .message').html('<div class="message-arrow"></div>Pentru a participa la această experiență, trebuie să ai cont pe site.').slideDown();
		} else {
			$('.message').hide();
			$(this).parents('.tab-pane.active').append('<div class="message"><div class="message-arrow"></div>Pentru a participa la această experiență, trebuie să ai cont pe site.</div>');
			$('.tab-pane.active .message').slideDown();
		}
	});

	$('.video-btn').click(function(e){
		e.preventDefault();
		player[$(this).data('video')] = new YT.Player($(this).next().attr('id'), {
			height: '360',
			width: '640',
			playerVars: {
				showinfo: 0,
				rel:0,
				autoplay:1,
				controls:1},
			videoId: $(this).data('video')
		});
		$("html, body").animate({ scrollTop: $(this).offset().top-50 });
	});

	$('.scrollto').click(function(e){
		e.preventDefault();
		scrollTo($(this).data('target'),$(this).data('offset'));
	});

	$('.video-step a').on('hide.bs.tab', function (e) {
        var playing = $('.tab-pane.active .video-btn').data('video');
        if(player[playing]) {
            if ( player[playing].getPlayerState() == 1 )
                player[playing].pauseVideo();
        }
	});

	new AjaxPostman('form.video-question',
		function(data){
			var playing = $('.tab-pane.active .video-btn').data('video');
			if(player[playing]) {
				if ( player[playing].getPlayerState() == 1 )
					player[playing].pauseVideo();
			}
			$(this).html(data).children('.video-question-row').animate({opacity: 1});
			$('#congratsModal').modal('show');
			ga('send','pageview','/streetfood/success');
		},
		function(xhr) {
			var response = '';
			if (xhr.responseJSON){
				for (var field in xhr.responseJSON) {
					for (var err in xhr.responseJSON[field])
						response  += xhr.responseJSON[field][err] + "<br>";
				}
			} else {
				response = xhr.responseText;
			}
			$(this).parents('.tab-pane').find('.message').remove();
			$(this).parents('.tab-pane').append('<div class="message"><div class="message-arrow"></div>'+response+'</div>');
			$('.message').slideDown();
		}
	);

	$('button[type=submit]').click(function(){
		$('.message').slideUp();
	})
});

$(window).load(function(){
	if ( window.location.hash.match(/#show[1,2]/g) ) {
		scrollTo('.video-step',-60);
	}
});
